import { ORIGINAL_BLOG_LANGUAGE, type BlogLanguage } from "./blogLanguages";

/**
 * 웹 경로.
 * @description 앱 `constants/routes.ts` 와 같은 모양으로 둔다 — 앱과 웹이 같은 주소를 쓰기로
 *   했고(딥링크가 그 전제다), 웹에 아직 화면이 없는 경로는 `[...path]` 브리지가 앱으로 넘긴다.
 * @example
 * <Link href={routes.collabs.detail(collab.collabId)} />
 */
export const routes = {
  home: "/",
  collabs: {
    detail: (collabId: number) => `/collabs/${collabId}`,
  },
  posts: {
    /** 앱 경로 — 웹에서는 브리지가 앱을 연다. 웹 상세는 `blog` 다 */
    detail: (postId: number) => `/posts/${postId}`,
  },
  blog: {
    /**
     * 웹의 글 상세 — 주소에 숫자가 아니라 슬러그를 쓴다(검색 엔진과 사람이 읽는다).
     * 원문(영어)은 접두사가 없고, 번역은 언어 코드가 앞에 선다(`/es/blog/{slug}`).
     */
    detail: (slug: string, language: BlogLanguage = ORIGINAL_BLOG_LANGUAGE) =>
      `${language === ORIGINAL_BLOG_LANGUAGE ? "" : `/${language}`}/blog/${encodeURIComponent(slug)}`,
  },
  profile: {
    byUsername: (username: string) =>
      `/profiles/${encodeURIComponent(username)}`,
  },
  organizations: {
    /** 앱 경로 — 팬베이스도 조직이라 이 주소로 연다(알림 딥링크와 같은 자리) */
    detail: (organizationId: number) => `/organizations/${organizationId}`,
  },
  legal: {
    terms: "/agreement/terms-of-service",
    /**
     * 개인정보 처리방침.
     * @description 슬러그가 `privacy-policy` 가 아닌 이유: 프로덕션 legal API 에는
     *   `PRIVACY_POLICY` 유형이 게시돼 있지 않아 그 주소는 404 다. 정작 처리방침 본문은
     *   `PRIVACY_COLLECTION_AND_USE` 유형으로 게시돼 있어 여기를 가리킨다
     *   (`sitemap.ts` 의 LEGAL_SLUGS 와 같은 사정). 서버가 `PRIVACY_POLICY` 를 게시하면
     *   `/agreement/privacy-policy` 로 되돌릴 것.
     */
    privacy: "/agreement/privacy-collection-and-use",
  },
  contact: "/contact",
} as const;
